import { useInfiniteQuery } from 'react-query';
import {
  CrmCustomerBaseRequest,
  CrmCustomerBirthdaysRequest,
  CrmCustomerCustomRequest,
  CrmCustomerFutureServicesRequest,
  CrmCustomerRecoveryDebtsRequest,
  CrmCustomerWithMovimentRequest,
} from './CrmList.types';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import {
  crmCustomerBirthdayList,
  crmCustomerCustomList,
  crmCustomerFutureServicesList,
  crmCustomerMarketingList,
  crmCustomerNextRevisionsList,
  crmCustomerRecoveryDebtsList,
  crmCustomerSatisfactionSurveysList,
  crmCustomerWithMovimentList,
} from './CrmList.services';

export function useCrmCustomerBirthdayList(
  params: CrmCustomerBirthdaysRequest,
) {
  return useInfiniteQuery(
    ['CrmCustomerBirthdays', { ...params }],
    ({ pageParam }) => {
      const req: CrmCustomerBirthdaysRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return crmCustomerBirthdayList(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );
}

export function useCrmCustomerCustomList(params: CrmCustomerCustomRequest) {
  return useInfiniteQuery(
    ['CrmCustomerCustoms', { ...params }],
    ({ pageParam }) => {
      const req: CrmCustomerCustomRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return crmCustomerCustomList(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );
}

export function useCrmCustomerSatisfactionSurveysList(
  params: CrmCustomerBaseRequest,
) {
  return useInfiniteQuery(
    ['CrmCustomerSatisfactionSurveys', { ...params }],
    ({ pageParam }) => {
      const req: CrmCustomerBaseRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return crmCustomerSatisfactionSurveysList(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );
}

export function useCrmCustomerMarketingList(params: CrmCustomerBaseRequest) {
  return useInfiniteQuery(
    ['CrmCustomerMarketing', { ...params }],
    ({ pageParam }) => {
      const req: CrmCustomerBaseRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return crmCustomerMarketingList(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );
}

export function useCrmCustomerFutureServiceList(
  params: CrmCustomerFutureServicesRequest,
) {
  return useInfiniteQuery(
    ['CrmCustomerFutureServices', { ...params }],
    ({ pageParam }) => {
      const req: CrmCustomerFutureServicesRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return crmCustomerFutureServicesList(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );
}

export function useCrmCustomerRecoveryDebtsList(
  params: CrmCustomerRecoveryDebtsRequest,
) {
  return useInfiniteQuery(
    ['CrmCustomerRecoveryDebts', { ...params }],
    ({ pageParam }) => {
      const req: CrmCustomerRecoveryDebtsRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return crmCustomerRecoveryDebtsList(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );
}

export function useCrmCustomerNextRevisionList(
  params: CrmCustomerCustomRequest,
) {
  return useInfiniteQuery(
    ['CrmCustomerNextRevisions', { ...params }],
    ({ pageParam }) => {
      const req: CrmCustomerCustomRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return crmCustomerNextRevisionsList(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );
}

export function useCrmCustomerWithoutMovimentList(
  params: CrmCustomerWithMovimentRequest,
) {
  return useInfiniteQuery(
    ['CrmCustomerWithoutMoviments', { ...params }],
    ({ pageParam }) => {
      const req: CrmCustomerWithMovimentRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return crmCustomerWithMovimentList(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
      enabled:
        (!!params.finalDate && !!params.initialDate) ||
        (!params.initialDate && !params.finalDate),
    },
  );
}
